import { Link } from "react-router-dom";

function FinalCTA({
  title = "Ready to put a lead through it?",
  description = null,
}) {
  return (
    <section className="overflow-hidden bg-[#191e1c] section-spacing">
      <div className="section-container">
        <div
          className="
            relative mx-auto flex min-h-[295px] w-full items-center
            justify-center overflow-hidden rounded-[28px]
            border border-[var(--mint-green)]/40
            bg-white/[0.035]
            px-5 py-12
            shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]
            backdrop-blur-xl
            sm:min-h-[310px] sm:rounded-[30px] sm:px-10
          "
        >
        {/* Green / olive glass glow */}
        <div
          aria-hidden="true"
          className="
            pointer-events-none absolute inset-0
            bg-[radial-gradient(circle_at_20%_50%,rgba(39,211,158,0.12),transparent_42%),radial-gradient(circle_at_82%_50%,rgba(190,185,58,0.13),transparent_45%)]
          "
        />

        {/* Soft center glass highlight */}
        <div
          aria-hidden="true"
          className="
            pointer-events-none absolute inset-0
            bg-gradient-to-b from-white/[0.035] via-transparent to-black/[0.04]
          "
        />

        {/* Content */}
        <div className="relative z-10 flex w-full flex-col items-center text-center">

          {/* Label */}
          <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--mint-green)] sm:text-[12px] uppercase mb-3">
            GET STARTED
          </p>

          {/* Heading */}
          <h2
            className="
              font-bricolage font-semibold
              text-[34px] leading-[1.05]
              tracking-[-1.4px] text-[#f4f7f5]
              sm:text-[40px]
              md:text-[44px]
            "
          >
            {title}
          </h2>

          {description && (
            <p className="mt-3 text-lg text-[#f1f1f1] sm:text-xl">
              {description}
            </p>
          )}


          {/* Buttons */}
          <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">

            {/* Primary */}
            <Link
              to="/for-dsas"
              className="
                inline-flex h-[58px] w-full items-center justify-center
                rounded-full
                bg-[var(--mint-green)]
                px-8
                font-jakarta text-[16px] font-medium
                text-[#071b17]
                transition-all duration-200
                hover:-translate-y-0.5
                hover:brightness-105
                focus:outline-none
                focus-visible:ring-2
                focus-visible:ring-[var(--mint-green)]
                focus-visible:ring-offset-2
                focus-visible:ring-offset-[#191e1c]
                sm:w-auto
              "
            >
              Join as a DSA
            </Link>

            {/* Secondary */}
            <Link
              to="/for-lenders"
              className="
                inline-flex h-[58px] w-full items-center justify-center
                rounded-full
                border border-white/[0.14]
                bg-white/[0.015]
                px-8
                font-jakarta text-[16px] font-semibold
                text-[#e8ecea]
                backdrop-blur-md
                transition-all duration-200
                hover:-translate-y-0.5
                hover:border-white/[0.28]
                hover:bg-white/[0.05]
                outline-none
                focus:outline-none
                sm:w-auto
              "
            >
              Partner as a lender
            </Link>

          </div>
        </div>
      </div>
    </div>
  </section>
  );
}

export default FinalCTA;